export default __webpack_public_path__ + "static/media/menu-sharp.0034fd7e.svg";